import React from 'react';
import { cn } from './utils/cn';

const MODE_THEME = {
  poker: {
    shell: 'from-[#07170f] via-[#0d2518] to-[#08160f]',
    lineTop: 'via-emerald-300/45',
    lineBottom: 'via-teal-300/35',
    orbA: 'bg-emerald-300/20',
    orbB: 'bg-teal-300/18',
    orbC: 'bg-lime-300/12',
    gridTint: 'from-emerald-300/[0.07] via-transparent to-teal-300/[0.06]',
  },
  seka: {
    shell: 'from-[#180f05] via-[#2a1709] to-[#1a0f06]',
    lineTop: 'via-amber-300/45',
    lineBottom: 'via-orange-300/35',
    orbA: 'bg-amber-300/20',
    orbB: 'bg-orange-300/18',
    orbC: 'bg-yellow-300/12',
    gridTint: 'from-amber-300/[0.07] via-transparent to-orange-300/[0.06]',
  },
  belot: {
    shell: 'from-[#110b1f] via-[#1b1331] to-[#110b23]',
    lineTop: 'via-violet-300/45',
    lineBottom: 'via-fuchsia-300/35',
    orbA: 'bg-violet-300/20',
    orbB: 'bg-fuchsia-300/18',
    orbC: 'bg-purple-300/12',
    gridTint: 'from-violet-300/[0.07] via-transparent to-fuchsia-300/[0.06]',
  },
};

export function ArcadeModeBackdrop({ mode = 'poker' }) {
  const theme = MODE_THEME[mode] || MODE_THEME.poker;

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden>
      <style>{`
        @keyframes arcade-drift-a {
          0%, 100% { transform: translate3d(0,0,0) scale(1); }
          50% { transform: translate3d(18px,-14px,0) scale(1.08); }
        }
        @keyframes arcade-drift-b {
          0%, 100% { transform: translate3d(0,0,0) scale(1); }
          50% { transform: translate3d(-20px,16px,0) scale(1.06); }
        }
        @keyframes arcade-grid-pan {
          0% { transform: translateY(0); opacity: 0.32; }
          50% { opacity: 0.52; }
          100% { transform: translateY(-18px); opacity: 0.32; }
        }
      `}</style>

      <div className={cn('absolute inset-0 bg-gradient-to-b', theme.shell)} />
      <div className={cn('absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent to-transparent', theme.lineTop)} />
      <div className={cn('absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent to-transparent', theme.lineBottom)} />

      <div className="absolute inset-0 overflow-hidden opacity-80">
        <div className={cn('absolute -left-20 top-8 h-56 w-56 rounded-full blur-3xl animate-[arcade-drift-a_10s_ease-in-out_infinite]', theme.orbA)} />
        <div className={cn('absolute -right-16 top-28 h-52 w-52 rounded-full blur-3xl animate-[arcade-drift-b_11s_ease-in-out_infinite]', theme.orbB)} />
        <div className={cn('absolute bottom-4 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full blur-3xl animate-[arcade-drift-a_12s_ease-in-out_infinite]', theme.orbC)} />
      </div>

      <div className={cn('absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.08),transparent_40%),linear-gradient(145deg,var(--tw-gradient-stops))]', theme.gridTint)} />
      <div className="absolute inset-0 bg-[linear-gradient(transparent_94%,rgba(255,255,255,0.06)_95%,transparent_96%)] bg-[length:100%_34px] animate-[arcade-grid-pan_8s_linear_infinite]" />
    </div>
  );
}

